import {RcfaComplianceLocationNode, RcfaComplianceTableData} from '@domain/rcfa'
import {CardBox, KpiScore, CardTitle} from '@hconnect/uikit/src/lib2'
import {InfoOutlined} from '@mui/icons-material'
import {Grid, Stack, Tooltip} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {getCompletedMandatoryRcfasText} from '../utils'

import {HeaderWithTooltip} from './HeaderWithTooltip'
import {RcfaComplianceGaugeBar} from './RcfaComplianceGaugeBar'
import {RcfaComplianceScore} from './RcfaComplianceScore'

export type RcfaComplianceCardProps = {
  data: RcfaComplianceTableData | RcfaComplianceLocationNode
  isMobile: boolean
  enterLocation: (location: RcfaComplianceLocationNode) => void
}

export const RcfaComplianceCard = ({data, isMobile, enterLocation}: RcfaComplianceCardProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const {id, name, rcfaCompliance} = data

  return (
    <CardBox
      data-test-id={`card-box-location-${name}`}
      onClick={() => enterLocation(data as RcfaComplianceLocationNode)}
      sx={{
        cursor: 'pointer'
      }}
    >
      <Stack spacing={2}>
        <CardTitle variant="h3" mb={0}>
          {name}
        </CardTitle>

        <Stack spacing={0.5}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <HeaderWithTooltip
              headerText={getCompletedMandatoryRcfasText(t)}
              tooltipText={t('tooltip.rcfaScore')}
              size="small"
            />
            <RcfaComplianceScore
              isMobile={isMobile}
              value={rcfaCompliance?.completedCount}
              maxValue={rcfaCompliance?.totalMandatoryCount || 0}
              dataTestId={`rcfa-compliance-score-${id}`}
            />
          </Stack>

          {rcfaCompliance && <RcfaComplianceGaugeBar rcfaCompliance={rcfaCompliance} />}
        </Stack>

        <Grid container>
          <Grid item xs={6}>
            <KpiScore
              label={t('label.unresolvedTasks')}
              value={rcfaCompliance?.unresolvedTasksCount}
              labelIcon={
                <Tooltip title={t('tooltip.unresolvedTasks')}>
                  <InfoOutlined />
                </Tooltip>
              }
            />
          </Grid>
          <Grid item xs={6}>
            <KpiScore
              label={t('label.overdueTasks')}
              value={rcfaCompliance?.overdueTasksCount}
              labelIcon={
                <Tooltip title={t('tooltip.overdueTasks')}>
                  <InfoOutlined />
                </Tooltip>
              }
            />
          </Grid>
        </Grid>
      </Stack>
    </CardBox>
  )
}
